import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, logInWithEmailAndPassword } from "../firebase/Firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { fetchUserName } from "../firebase/snippets/Controller";

import { HeroCentered, HeroSplitDefault } from '../../components/default-sections/Hero';
import Devider from '../../components/default-sections/Devider';
import RecentCards from '../../components/main/RecentCards';

import { advertisment } from "../../assets/const/Images";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, loading] = useAuthState(auth);

  const navigate = useNavigate();
  useEffect(() => {
    if (loading) {
      // maybe trigger a loading screen
      return;
    }
    if (user){
      fetchUserName(user)
        .then((name) => {
          localStorage.setItem('user', JSON.stringify({ name: name }));
        })
      navigate("/dashboard");
    } 
  }, [user, loading, navigate]);



  const loginForm = () => {
    return (

      <div className="col-md-10 mx-auto col-lg-10">
        <form className="p-4 p-md-5 border rounded-3 bg-light">
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-mail Address"
            />
            <label htmlFor="floatingInput">Email address</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="password"
              autoComplete=""
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
            />
            <label htmlFor="floatingPassword">Password</label>
          </div>


          <button
            onClick={() => logInWithEmailAndPassword(email, password)}
            className="w-100 btn btn-lg btn-primary"
            type="button"
            data-te-ripple-init
            data-te-ripple-color="light"
            style={{ background: "linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593)" }}>
            Log in
          </button>
          <hr className="my-4" />
          <p><small className="text-muted centered">Not yet registered ? Create a new Account</small></p>
          <button className="w-100 btn btn-lg btn-primary" type="button" onClick={() => navigate("/register")}>Register</button>
        </form>
      </div>



    );
  }

  return (

    <>
      <HeroCentered
        title="Code Snippet Platform"
        content="Cloud Storage for code snippets. Search and commit code snippets for various coding languages. Comment and rate
        commits from the community to improve the code quality of all projects, created by the community. In addition, AI is going
        to submit snippets, to provide even further content to everyone."
        image={advertisment.browser} />
      <Devider />
      <RecentCards/>
      <Devider />
      <HeroSplitDefault
        leftHeader="Login"
        leftContent="Login or register to become part of this community and participate in all events. Commit and rate content that
        has been created by other users."
        rightContent={loginForm()} />
    </>

  );
}
export default Login;
